import React from 'react';
import { Link } from 'react-router-dom';

let count = 0;
// a content generator
// options
// label: Shows in TH
// headClass: css class applied to `th`
// class: css class applied to `td`
// link: to: url string, label: the link's content
// mask: a function to run on the contents of the `td`
// dive: specify a child object's property, or an array of nested properties
// raw: a string or component
// combine: an array of multiple specs
export const generateContent = (data, specs, i = 1, dashIfNull = true) => {
  count += 1;
  if (!data) return '';
  if (Array.isArray(data)) {
    return data.map(d => generateContent(d, specs, i));
  }

  const temp = specs.key ? data[specs.key] : data;
  const value = specs.dive ? dive(specs.dive, temp) : temp;

  let content = '';
  if (specs.link) content = buildLink(specs.link, data);
  else if (specs.onClick) 
    content = <a className="a--blue" onClick={() => { specs.onClick(value) }}>{specs.raw}</a>
  else if (specs.raw) content = specs.raw 
  else if (specs.transform) {
    content = specs.transform(data) 
  }
  else if (specs.combine) {
    const combined = [];
    specs.combine.forEach((spec, key) =>
      combined.push(generateContent(value, spec, key, false))
    );
    if (combined.filter(item => item).length > 0) {
      content = <p>{combined.map(item => item)}</p>;
    } 
  } else content = applyMask(specs, value);

  if (!dashIfNull && !content) return null

  content = toString(content);
  content = specs.className ? (
    <span key={`${count}-${i}`} className={specs.className}>
      {content}
    </span>
  ) : (
    <span key={`${count}-${i}`}>{content}</span>
  );

  return content;
};

// helper functions

export const applyMask = (specs, value) => {
  return specs.mask ? specs.mask(value) : value;
};

export const buildLink = (link, data) => {
  const label = link.advancedLabel
    ? generateContent(data, link.advancedLabel)
    : link.label;
  return link.crossOrigin ? (
    <a
      href={mapString(link.to, data)}
      className="a--blue"
      target={link.target || '_self'}
    >
      {label}
    </a>
  ) : (
    <Link
      to={mapString(link.to, data)}
      className="a--blue"
      target={link.target || '_self'}
    >
      {label}
    </Link>
  );
};

/**
 * 'Dives' deeper into an object
 * @param key
 * @param obj
 * @returns {*}
 */
export const dive = (key, obj) => {
  // if the key is an array, map one after the other
  if (obj && Array.isArray(key)) {
    let value = Array.isArray(obj) ? [...obj] : { ...obj };
    key.forEach(k => (value = dive(k, value)));
    return value;
  }
  // if object is array, combine to single output
  if (Array.isArray(obj)) {
    return obj.map(item => item[key]);
  }

  // otherwise return the property
  return obj && key in obj ? obj[key] : '';
};

/**
 * Updates a string with properties from an object.
 * @param string The string to be mapped. `/product/[id]` will be replaced with the 'id' property
 * from the provided object
 * @param data The object
 * @returns {string} The updated string
 */
export function mapString(string, data) {
  const re = /\[(.*?)\]/;
  const split = string.split(re);
  const parts = split.map((part, i) => {
    if (i % 2) return part in data ? data[part] : part;
    else return part;
  });
  return parts.join('');
}

/**
 * Joins an array of strings
 * @param value string/array
 * @returns string
 */
export const toString = value => {
  if (Array.isArray(value)) return value.join(', ');

  if (value === '') return String.fromCharCode(8212); // —

  return value;
};



// WEBPACK FOOTER //
// ./src/helpers/plunger.js